import { useSettings } from '@wu/widget-core';
import { Background, EmptyMessage, StyledFreeLink } from './components';
import { styles } from './styles';
import { useAddSiteLanguage } from './utils/use-add-site-language';
import { useSaveLanguage } from './utils/use-save-language';

export function Widget() {
  const { style } = useSettings();

  const updateLanguage = useSaveLanguage();
  const languages = useAddSiteLanguage();

  const hasLanguages = languages && languages.length > 0;

  const Style = styles[style];

  return (
    <>
      <Background itemsLength={languages?.length}>
        {hasLanguages && <Style items={languages} onClick={updateLanguage} />}
        {!hasLanguages && <EmptyMessage />}
      </Background>

      <StyledFreeLink />
    </>
  );
}
